const project = {
  //animation speed
  speed: 25,
  phoneSpeed: 25,

  //Speed of scroll when automatic button is pressed
  autoSpeed: 30,

  //dont show at the start the 3d model
  appearAndDisapear: true,

  //3d model
  images: {
    directory: "/static/formule/",

    startWith: "",
    padStart: false,

    nbImgs: 737,
    extension: "png",
  },

  //text to display
  //always start  at 1
  text: [
    //Never delete this one
    {
      title: "message.project.default.animation",
      label: "message.project.default.label",
      imageCount: 0,
    },
    //end
    //Ele 1-106
    //Dynamics 107-226
    //Drivetrain 227-312
    //Powertrain 313-386
    //Chassis 387-500
    //Aero 500-588
    //Media 589-fin
    {
      title: "message.project.text.electronics.title",
      label: "message.project.text.electronics.label",
      imageCount: 1,
    },
    {
      title: "message.project.text.dynamics.title",
      label: "message.project.text.dynamics.label",
      imageCount: 107,
    },
    {
      title: "message.project.text.drivetrain.title",
      label: "message.project.text.drivetrain.label",
      imageCount: 227,
    },
    {
      title: "message.project.text.powertrain.title",
      label: "message.project.text.powertrain.label",
      imageCount: 313,
    },
    {
      title: "message.project.text.chassis.title",
      label: "message.project.text.chassis.label",
      imageCount: 387,
    },
    {
      title: "message.project.text.aerodynamics.title",
      label: "message.project.text.aerodynamics.label",
      imageCount: 500,
    },
    {
      title: "message.project.text.thank.title",
      label: "message.project.text.thank.label",
      imageCount: 589,
    },
  ],
};

export default project;
